import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef, useState } from 'react';
import { Button } from '../../primitives/Button/Button.js';
import { fichiersDuChoix, fichiersDuGlisser } from './collecte.js';
import styles from './ZoneDepot.module.css';
/**
 * Zone de dépôt de fichiers ET de dossiers (ARTO-129) : glisser-déposer, ou
 * deux boutons — des fichiers, ou un dossier entier (`webkitdirectory`), son
 * arborescence gardée. Le glisser n'est qu'un raccourci : les boutons suffisent
 * au clavier et aux lecteurs d'écran.
 */
export function ZoneDepot({ onFichiers, desactive = false, libelles, }) {
    const choixFichiers = useRef(null);
    const choixDossier = useRef(null);
    const [survol, setSurvol] = useState(false);
    const recevoir = (fichiers) => {
        if (fichiers.length > 0)
            onFichiers(fichiers);
    };
    const deposer = (evenement) => {
        evenement.preventDefault();
        setSurvol(false);
        if (desactive)
            return;
        void fichiersDuGlisser(evenement.dataTransfer).then(recevoir);
    };
    return (_jsxs("div", { className: styles.zone, "data-survol": survol || undefined, "data-desactive": desactive || undefined, onDragOver: (evenement) => {
            evenement.preventDefault();
            if (!desactive)
                setSurvol(true);
        }, onDragLeave: () => setSurvol(false), onDrop: deposer, children: [_jsx("p", { className: styles.consigne, children: libelles.consigne }), _jsxs("div", { className: styles.actions, children: [_jsx(Button, { variant: "secondary", size: "sm", disabled: desactive, onClick: () => choixFichiers.current?.click(), children: libelles.fichiers }), _jsx(Button, { variant: "secondary", size: "sm", disabled: desactive, onClick: () => choixDossier.current?.click(), children: libelles.dossier })] }), _jsx("input", { ref: choixFichiers, className: styles.cache, type: "file", multiple: true, tabIndex: -1, "aria-hidden": "true", "data-testid": "zone-depot-fichiers", onChange: (evenement) => {
                    recevoir(fichiersDuChoix(evenement.currentTarget.files ?? []));
                    evenement.currentTarget.value = '';
                } }), _jsx("input", { ref: choixDossier, className: styles.cache, type: "file", multiple: true, tabIndex: -1, "aria-hidden": "true", "data-testid": "zone-depot-dossier", webkitdirectory: '', directory: '', onChange: (evenement) => {
                    recevoir(fichiersDuChoix(evenement.currentTarget.files ?? []));
                    evenement.currentTarget.value = '';
                } })] }));
}
//# sourceMappingURL=ZoneDepot.js.map